import {combineReducers} from "redux";
import modifierProfilReducer from "./modifierProfil";

export default combineReducers({
    modifierProfil : modifierProfilReducer,
});